import { routerReducer } from 'react-router-redux';
import { ApiReducer as api } from 'reactifi-local';

export default {
  routing: routerReducer,
  api,
};
